import { useContext, useEffect, useState } from "react";
import MinusRed from "../../../../Assets/StorefrontIcons/MinusRed.svg";
import { AddSizeChartContext } from "../../../../Context/AddSizeChartContext";
import { closeModal } from "../../../../Features/inventoryManagementSlice";
import { useDispatch } from "react-redux";
import HeaderSection from "./HeaderSection";
import InputSection from "./InputSection";

function RowRemoveModal() {
    const dispatch = useDispatch();
    const [localData, setLocalData] = useState([]);
    const [categoryKeys, setCategoryKeys] = useState([]);

    const { sizeChartFormData, setSizeChartFormData } = useContext(AddSizeChartContext);

    const formatHeaderTitle = (text) => {
        if (!text) return "";
        return text
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (s) => s.toUpperCase())
            .trim();
    };

    function handleRemoveRow(id) {
        const filteredList = localData.filter((item) => item.id !== id);
        setLocalData(filteredList);
    }

    useEffect(() => {
        if (sizeChartFormData.length > 0) {
            setLocalData(sizeChartFormData);
        }
    }, [sizeChartFormData]);

    useEffect(() => {
        if (sizeChartFormData.length === 0) return;
        const currentKeys = Object.keys(sizeChartFormData[0]).filter((k) => k !== "id");
        setCategoryKeys(currentKeys);
    }, [sizeChartFormData]);

    function handleSave() {
        setSizeChartFormData(localData);
        dispatch(closeModal());
    }

    function handleCloseModal() {
        dispatch(closeModal());
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="w-full overflow-x-scroll flex flex-col">
                <div className="border-l border-[#EAEAEA]">
                    {/* Header Row */}
                    <div className="w-full flex items-center">
                        {categoryKeys.map((key, index) => {
                            const isLast = index === categoryKeys.length - 1;

                            if (key === "sizeName") {
                                return (
                                    <div
                                        key={key}
                                        className={`w-[180px] shrink-0 h-[94px] px-6 py-3 flex items-center justify-center border-b border-t ${
                                            !isLast && "border-r border-[#EAEAEA]"
                                        }`}
                                    >
                                        <p>Size</p>
                                    </div>
                                );
                            }

                            return <HeaderSection key={key} title={formatHeaderTitle(key)} />;
                        })}
                    </div>

                    {/* Body Rows */}
                    <div className="max-h-80 flex flex-col w-full">
                        {localData.length > 0 &&
                            localData.map((row) => (
                                <div key={row.id} className="w-full flex items-center">
                                    <div className="w-full flex items-center">
                                        {categoryKeys.map((key, keyIndex) => {
                                            const isLast = keyIndex === categoryKeys.length - 1;

                                            if (key === "sizeName") {
                                                return (
                                                    <div
                                                        key={`${row.id}-${key}`}
                                                        className={`w-[180px] border-b shrink-0 px-6 py-3 ${
                                                            !isLast && "border-r border-[#EAEAEA]"
                                                        }`}
                                                    >
                                                        <p
                                                            className={`${
                                                                row.sizeName ? "" : "text-[#A0A0A0]"
                                                            } w-full outline-none placeholder:text-center text-center`}
                                                        >
                                                            {row.sizeName ? row.sizeName : "input"}
                                                        </p>
                                                    </div>
                                                );
                                            }

                                            return (
                                                <InputSection
                                                    key={`${row.id}-${key}`}
                                                    centimeters={row[key]?.cm || ""}
                                                    inches={row[key]?.in || ""}
                                                />
                                            );
                                        })}

                                        <div className="w-[60px] shrink-0 flex">
                                            <button
                                                onClick={() => handleRemoveRow(row.id)}
                                                className="mx-auto select-none size-[18px] flex items-center justify-center"
                                            >
                                                <img src={MinusRed} alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

            {/* Footer Buttons */}
            <div className="flex items-center justify-end">
                <button
                    onClick={handleCloseModal}
                    className="px-5 py-[10px] rounded outline-none text-[#757575] text-base font-semibold"
                >
                    Cancel
                </button>

                <button
                    onClick={handleSave}
                    className="px-5 py-[10px] rounded outline-none text-white bg-primaryColor hover:bg-primaryAccent text-base font-semibold"
                >
                    Save
                </button>
            </div>
        </div>
    );
}

export default RowRemoveModal;
